
import focusMixin from '@/features/common/mixins/focusMixin';
import {
  Component, Prop, Mixins,
} from 'vue-property-decorator';

@Component
export default class Notification extends Mixins(focusMixin) {
  @Prop({ required: true }) cutoffTime!: string;

  private show = false;
}
